/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 127,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						// console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		toggleFixedFooterMenu() {
			const recruitFooter = document.querySelector(".recruit-footer");
			const headerNav = document.querySelector(".header-nav-fixed[data-view='sp,tablet']");

			if (!recruitFooter || !headerNav) return;

			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						// .recruit-footer が画面内に入ったらクラスを追加
						headerNav.classList.add("hide");
					} else {
						// .recruit-footer が画面外に出たらクラスを削除
						headerNav.classList.remove("hide");
					}
				});
			}, { threshold: 0.1 }); // 10%以上表示されたら反応

			observer.observe(recruitFooter);

		},
		headerMegamenu() {
			const header = document.querySelector('header');
			const noTransition = 'is-noTransition';
			const activeClass = 'is-active';

			// メガメニューを閉じる関数
			const menuClose = () => {
				const activeBtn = document.querySelectorAll(`.js-megaMenu.${activeClass}`);
				const activeBlock = document.querySelectorAll(`.js-megaMenu-block.${activeClass}`);
				const searchButton = document.querySelectorAll(`.js-header-search.${activeClass}`);


				document.querySelectorAll('.js-megaMenu-block').forEach(block => {
					block.classList.toggle(noTransition, !activeBlock.length);
				});

				activeBtn.forEach(btn => btn.classList.remove(activeClass));
				activeBlock.forEach(block => block.classList.remove(activeClass));
				searchButton.forEach(search => search.classList.remove(activeClass));
			};

			const searchToggle = () => {
				const searchButton = document.querySelector('.js-header-search');
				if (searchButton) {
					searchButton.addEventListener('click', () => {
						header.classList.add('is-scroll');

						const thisName = searchButton.getAttribute('data-name');
						const targetBlock = document.querySelector(`.js-megaMenu-block[data-name="${thisName}"]`);

						const isActive = searchButton.classList.contains(activeClass);

						if (isActive) {
							menuClose();
						} else {
							searchButton?.classList.add(activeClass);
							targetBlock?.classList.add(activeClass);
						}
					});
				}
			}

			// メガメニューの初期化
			const initializeMegaMenu = () => {
				const megaMenuLinks = document.querySelectorAll('.header-nav-main-item > a.__link');

				if (FUNCTIONS.va.pathname.startsWith("/recruit/message/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/personality/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/infographics/")) {
					const recruitElement = document.querySelector('[data-name="recruit01"]');
					if (recruitElement) {
						recruitElement.classList.add("current");
					}
				}

				if (FUNCTIONS.va.pathname.startsWith("/recruit/initiative/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/jobs/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/technical/")) {
					const recruitElement = document.querySelector('[data-name="recruit02"]');
					if (recruitElement) {
						recruitElement.classList.add("current");
					}
				}

				if (FUNCTIONS.va.pathname.startsWith("/recruit/mind/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/career-plan/") ||
					FUNCTIONS.va.pathname.startsWith("/recruit/welfare/")) {
					const recruitElement = document.querySelector('[data-name="recruit03"]');
					if (recruitElement) {
						recruitElement.classList.add("current");
					}
				}

				megaMenuLinks.forEach(link => {
					// カレント設定
					if (FUNCTIONS.va.pathname.startsWith(link.getAttribute('href'))) {
						link.classList.add('current');
					}

					// マウスオーバーイベント
					let hoverTimeout; // 遅延用のタイマー

					link.addEventListener('mouseover', () => {
						hoverTimeout = setTimeout(() => {
							menuClose();
							header.classList.add('is-scroll');

							if (link.classList.contains('js-megaMenu')) {
								const thisName = link.getAttribute('data-name');
								const targetBlock = document.querySelector(`.js-megaMenu-block[data-name="${thisName}"]`);

								link.classList.add(activeClass);
								targetBlock?.classList.add(activeClass);
							} else {
								document.querySelectorAll('.js-megaMenu-block').forEach(block => {
									block.classList.remove(noTransition);
								});
							}
						}, 200); // 200ms の遅延（調整可能）
					});

					// **マウスが外れたら遅延をキャンセル**
					link.addEventListener('mouseleave', () => {
						clearTimeout(hoverTimeout);
					});

					// キーボード操作（Enter/ESC/Shift+Tab）
					link.addEventListener('keydown', e => {
						if (e.key === 'Enter') {
							menuClose();
							header.classList.add('is-scroll');

							if (link.classList.contains('js-megaMenu')) {
								const thisName = link.getAttribute('data-name');
								const targetBlock = document.querySelector(`.js-megaMenu-block[data-name="${thisName}"]`);
								const isActive = targetBlock?.classList.contains(activeClass);

								if (isActive) {
									setTimeout(() => {
										link.setAttribute('href', link.getAttribute('data-href'));
									}, 100);
								} else {
									link.setAttribute('data-href', new URL(link.href).pathname);
									link.setAttribute('href', 'javascript:void(0)');
								}

								link.classList.toggle(activeClass);
								targetBlock?.classList.toggle(activeClass);
							}
						} else if (e.key === 'Escape') {
							menuClose();
						} else if (e.shiftKey && e.key === 'Tab') {
							menuClose();
						}
					});
				});
			};

			// メガメニュー内の要素でESCキー操作
			const initializeMegaMenuKeyboard = () => {
				document.querySelectorAll('.header-nav-main a, .header-nav-main button').forEach(element => {
					element.addEventListener('keydown', e => {
						if (e.key === 'Escape') menuClose();
					});
				});
			};

			// オーバーレイでメガメニュー非表示
			const initializeOverlayClose = () => {
				document.querySelectorAll('.header-megamenu-overlay').forEach(overlay => {
					overlay.addEventListener('mouseover', menuClose);
				});
			};

			// SPメガメニュー開閉
			const initializeSpMegaMenu = () => {
				const spMegaMenuButtons = document.querySelectorAll('button.js-megaMenu');
				spMegaMenuButtons.forEach(button => {
					button.addEventListener('click', e => {
						const thisName = e.currentTarget.getAttribute('data-name');
						const targetBlock = document.querySelector(`.js-megaMenu-block[data-name="${thisName}"]`);

						e.currentTarget.classList.toggle(activeClass);
						targetBlock?.classList.toggle(activeClass);
					});
				});
			};

			// ページ内リンク処理
			const initializeScrollLinks = () => {
				const scrollItems = document.querySelectorAll('.js-megamenuLink-scroll');
				scrollItems.forEach(item => {
					const hrefPath = item.getAttribute('href').split('#')[0];
					if (hrefPath === FUNCTIONS.va.pathname) {
						item.setAttribute('rel', 'scroll');
						FUNCTIONS.easeScroll();
					}
				});
			};

			// 初期化関数を実行
			searchToggle();
			initializeMegaMenu();
			initializeMegaMenuKeyboard();
			initializeOverlayClose();
			initializeSpMegaMenu();
			initializeScrollLinks();
		},
		toggleLanguageMenu() {
			const langButton = document.querySelector('.js-header-lang');
			const langBlock = document.querySelector('.js-header-lang-block');
			const activeClass = 'is-active';

			if (langButton && langBlock) {
				langButton.addEventListener('click', (event) => {
					event.stopPropagation(); // クリックイベントの伝播を防ぐ
					langButton.classList.toggle(activeClass);
					langBlock.classList.toggle(activeClass);
				});

				// 領域外クリックで閉じる処理
				document.addEventListener('click', (event) => {
					if (!langBlock.contains(event.target) && !langButton.contains(event.target)) {
						langBlock.classList.remove(activeClass);
						langButton.classList.remove(activeClass);
					}
				});
			}
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const content = ele.querySelector('.mod-accordion-content');
				const plus = ele.querySelector('.mod-accordion-plus');

				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						};
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});

			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length && $content.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target') && ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target') && ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {

				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						if (document.getElementById(hash)) {
							const focusableElements = Array.from(
								document.getElementById(hash).querySelectorAll(focusableElementsSelector)
							);
							if (focusableElements.length) {
								focusableElements[0].focus();
							}
						}

					}
				}

				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
							resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}

				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';
					document.querySelectorAll("img").forEach(img => {
						img.setAttribute("loading", "eager");
					});

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let pagetop = document.querySelector('.footer-pagetop');

			if (pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						pagetop.classList.add(v);
					} else {
						pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML, _target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
									document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

			$elements.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				if (!groups.has(attributeName)) {
					groups.set(attributeName, []);
				}
				groups.get(attributeName).push(ele);
			});
			groups.forEach(group => {
				const attributeGroups = new Map();
				const TOLERANCE = 5; // 許容範囲（±5px）

				group.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;

					// 許容範囲に合わせて丸める
					const roundedTop = Math.round(topPosition / TOLERANCE) * TOLERANCE;
					const key = attributeName + '_' + roundedTop;

					if (!attributeGroups.has(key)) {
						attributeGroups.set(key, []);
					}
					attributeGroups.get(key).push(ele);
				});
				attributeGroups.forEach((item) => {
					const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
					item.forEach((ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			});
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {

					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		headerHamburger() {
			const header = document.querySelector('header');
			const $hamburger = document.querySelector('.header-hamburger');
			const $nav = document.querySelector('.header-nav');
			const $container = document.querySelector('.container');
			let scrollTopNow;

			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				document.body.classList.add(f);
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo({ top: scrollTopNow });
			};

			if ($hamburger) {
				$hamburger.addEventListener('click', (e) => {
					e.currentTarget.classList.toggle(a);
					header.classList.add('is-scroll');
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(v);
						$nav.classList.remove(a);
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						setTimeout(() => { $nav.classList.add(v); });
					}
				});
			}
		},
		subMenuHamburger() {
			const hamburger = document.querySelector('.sub-menu-button');
			const nav = document.querySelector('.sub-menu-content');
			const $container = document.querySelector('.container');

			const fixedOnContainer = () => {
				if (window.innerWidth <= 1024) {
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
				}


				document.body.classList.add(f);
			};
			const fixedOffContainer = () => {
				if (window.innerWidth <= 1024) {
					$container.style.position = 'static';
					document.body.classList.remove(f);
					window.scrollTo({ top: scrollTopNow });
				} else {
					document.body.classList.remove(f);
				}

			};

			if (hamburger) {
				hamburger.addEventListener('click', (e) => {
					e.currentTarget.classList.toggle(a);
					if (nav.classList.contains(a)) {
						nav.classList.remove(v);
						nav.classList.remove(a);
						fixedOffContainer();
					} else {
						fixedOnContainer();
						nav.classList.add(a);
						setTimeout(() => { nav.classList.add(v); });
					}
				});

				let lastScrollTop = 0; // 最後のスクロール位置を記録
				const target = document.querySelector('.header'); // クラスを付与する要素
				const target2 = document.querySelector('.sub-menu'); // クラスを付与する要素

				window.addEventListener('scroll', () => {
					let scrollTop = window.scrollY || document.documentElement.scrollTop;

					if (scrollTop > lastScrollTop) {
						// 下にスクロール
						target.classList.add('scrolled');
						target2.classList.add('scrolled');
					} else {
						// 上にスクロール
						target.classList.remove('scrolled');
						target2.classList.remove('scrolled');
					}

					lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // 負の値にならないように調整
				});
			}
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// console.log("----- removeElmIfEmpty -----")
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (ele.textContent.trim() === "" && ele.children.length === 0) {
					// console.log("削除する", ele)
					ele.remove();
				} else {
					// console.log("削除しない")
				}
			});
		},
		removeBlockIfListEmpty() {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li')) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		addScrollClassToHeader() {
			const container = document.querySelector('.container.top');
			const recruitContainer = document.querySelector('.container.recruit-top');

			if (container || recruitContainer) {
				// container または recruitContainer のどちらかが存在すればOK
				const targetContainer = container || recruitContainer; // 存在するほうを使う
				const header = targetContainer.querySelector('.header'); // .headerを取得
				const scrollClass = 'is-scroll'; // 付与するクラス名

				if (header) {
					// スクロールイベントを監視
					window.addEventListener('scroll', function () {
						if (window.scrollY > 0 && !document.querySelector('.header-nav.is-active')) {
							header.classList.add(scrollClass); // スクロールしたらクラスを付与
						} else {

							// js-megaMenuに.is-activeが無い場合のみクラスを削除
							if (!document.querySelector('.js-megaMenu.is-active') && !document.querySelector('.header-nav.is-active')) {

								header.classList.remove(scrollClass); // スクロール位置がトップならクラスを削除
							}
						}
					});
				}
			}
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.headerHamburger();
			_this.subMenuHamburger();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.addScrollClassToHeader();
			_this.headerMegamenu();
			_this.toggleLanguageMenu();
			_this.toggleFixedFooterMenu();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
